import { render } from "./imgUpLoad.vue?vue&type=template&id=353351ef&scoped=true"
import script from "./imgUpLoad.vue?vue&type=script&lang=js"
export * from "./imgUpLoad.vue?vue&type=script&lang=js"

import "./imgUpLoad.vue?vue&type=style&index=0&id=353351ef&scoped=true&lang=css"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353351ef"]])

export default __exports__